import api from './api';

export interface UserPrivilege {
  id: number;
  name: string;
  manage_users: boolean;
  all_patients: boolean;
  questionnaires: boolean;
  email_and_sms_templates: boolean;
  config: boolean;
  config_sync: boolean;
  file_types: boolean;
  task_types: boolean;
  wellness: boolean;
  prompt_development: boolean;
  doc_assistant: boolean;
  clinic_login: boolean;
  hmo: boolean;
  referral: boolean;
  leads: boolean;
  view_video_rooms: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserPrivilegeCreate {
  name: string;
  manage_users?: boolean;
  all_patients?: boolean;
  questionnaires?: boolean;
  email_and_sms_templates?: boolean;
  config?: boolean;
  config_sync?: boolean;
  file_types?: boolean;
  task_types?: boolean;
  wellness?: boolean;
  prompt_development?: boolean;
  doc_assistant?: boolean;
  clinic_login?: boolean;
  hmo?: boolean;
  referral?: boolean;
  leads?: boolean;
  view_video_rooms?: boolean;
}

export interface UserPrivilegeUpdate {
  name?: string;
  manage_users?: boolean;
  all_patients?: boolean;
  questionnaires?: boolean;
  email_and_sms_templates?: boolean;
  config?: boolean;
  config_sync?: boolean;
  file_types?: boolean;
  task_types?: boolean;
  wellness?: boolean;
  prompt_development?: boolean;
  doc_assistant?: boolean;
  clinic_login?: boolean;
  hmo?: boolean;
  referral?: boolean;
  leads?: boolean;
  view_video_rooms?: boolean;
}

export const userPrivilegeService = {
  async getUserPrivileges(): Promise<UserPrivilege[]> {
    const response = await api.get('/user-privileges/');
    return response.data;
  },

  async getUserPrivilege(privilegeId: number): Promise<UserPrivilege> {
    const response = await api.get(`/user-privileges/${privilegeId}`);
    return response.data;
  },

  async createUserPrivilege(data: UserPrivilegeCreate): Promise<UserPrivilege> {
    const response = await api.post('/user-privileges/', data);
    return response.data;
  },

  async updateUserPrivilege(privilegeId: number, data: UserPrivilegeUpdate): Promise<UserPrivilege> {
    const response = await api.patch(`/user-privileges/${privilegeId}`, data);
    return response.data;
  },

  async deleteUserPrivilege(privilegeId: number): Promise<void> {
    await api.delete(`/user-privileges/${privilegeId}`);
  },
};
